import qs from "qs";
import { Dialog } from "vant";
import { getUserIdAsToken } from "@/utils/public.js";
let query = qs.parse(location.search.slice(1));

export default {
    param() {
        let appLogin = sessionStorage.getItem(`INVERTADVISER_APP_LOGIN`);
        if (appLogin) {
            appLogin = JSON.parse(appLogin);
        } else {
            appLogin = {
                token: query.token,
                userId: query.userId,
            };
        }

        return {
            source: "APP",
            token: appLogin.token,
            userId: appLogin.userId || getUserIdAsToken(appLogin.token),
        };
    },
    linkSearch(param) {
        return `${qs.stringify({ ...this.param(), ...param })}`;
    },
    isLogin() {
        const { token } = this.param();
        if (token && token != "0") {
            return Promise.resolve(true);
        } else {
            return Promise.reject(false);
        }
    },
    goToLogin(vm) {
        Dialog.confirm({
            title: "温馨提示",
            message: "请登录APP",
        }).then(() => {
            window.HmsApp.goToLoginPage().then((res) => {
                let data = res.data;
                if (data) {
                    //data ios:userToken,userID , android:token,userId
                    sessionStorage.setItem(
                        `INVERTADVISER_APP_LOGIN`,
                        JSON.stringify({
                            token: data.userToken || data.token,
                            userId: data.userID || data.userId,
                        })
                    );
                    location.reload();
                }
            });
        });
    },
};
